import { insertInArray } from '@plone/volto/helpers/Utils/Utils';
import baseMessages from '@fhnw/messages/base';

export const imageBlockSchemaEnhancer = ({ formData, schema, intl }) => {
  if (formData.url) {
    schema.fieldsets[0].fields = insertInArray(
      schema.fieldsets[0].fields,
      'description',
      1,
    );
    schema.fieldsets[0].fields = insertInArray(
      schema.fieldsets[0].fields,
      'format',
      4,
    );
    schema.fieldsets[0].fields = insertInArray(
      schema.fieldsets[0].fields,
      'focus_point',
      5,
    );
    if (formData.size !== 'large' && formData.align !== 'center') {
      schema.fieldsets[0].fields = insertInArray(
        schema.fieldsets[0].fields,
        'float',
        3,
      );
    }
  }

  schema.properties.alt = {
    title: intl.formatMessage(baseMessages.AlternativeText),
  };
  schema.properties.description = {
    title: intl.formatMessage(baseMessages.Caption),
  };
  schema.properties.format = {
    title: intl.formatMessage(baseMessages.Format),
    widget: 'format_widget',
    default: 'none',
  };
  schema.properties.focus_point = {
    title: intl.formatMessage(baseMessages.FocusPoint),
    widget: 'focus_point_widget',
    default: 'center_center',
    vocabulary: {
      '@id': '/@vocabularies/fhnw.vocabularies.image_cropping_options',
    },
  };
  schema.properties.size = {
    title: schema.properties.size.title,
    widget: 'select',
    default: 'large',
    choices: [
      ['large', intl.formatMessage(baseMessages.SizeLarge)],
      ['half', intl.formatMessage(baseMessages.SizeHalf)],
      ['third', intl.formatMessage(baseMessages.SizeThird)],
      ['portrait', intl.formatMessage(baseMessages.SizePortrait)],
      ['original', intl.formatMessage(baseMessages.SizeOriginal)],
    ],
  };
  schema.properties.float = {
    title: intl.formatMessage(baseMessages.Float),
    widgetOptions: {
      frontendOptions: {
        widget: 'checkbox',
      },
    },
  };
  schema.properties.align.disable = formData.size === 'large';

  return schema;
};
